// Module
var code = "<div id=\"V-3352C036-F058-4968-91CD-6AC83CF7A089\"> <i data-b-class-additioanl=\"{Binding IconClass}\" data-b-attr-class=\"{Binding Class}\" data-b-attr-style=\"{Binding Style}\"></i> </div> ";
// Exports
export default code;